import AbTestProvider from './abTestProvider'

export default function ({ nuxtState }, inject) {
    inject('abTest', new AbTestProvider(nuxtState.$abTest))
}
